import { useEffect, useState } from "react";
import { INIT_INFO_TEACHER_ATTENDANCE } from "../constants";
import { requestGetInfoTeacherAttendance } from "services/events/attendance";
import useMainContext from "utils/context/useMainContext";

const useDataTeacherAttendance = ({ eventData }) => {
	const mainContext = useMainContext();
	const [data, setData] = useState({
		...INIT_INFO_TEACHER_ATTENDANCE,
	});
	const [isLoaded, setIsLoaded] = useState(false);
	useEffect(() => {
		if (!eventData.isLoaded) return;
		fillData().then(() => setIsLoaded(true));
	}, [eventData.isLoaded]);
	const fillData = async () => {
		// Recuperando información de la asistencia del tutor
		const data = await requestGetInfoTeacherAttendance(
			eventData.value.dateEventId
		);
		if (!data) mainContext.setShowDialogUnexpectedError(true);
		else setData(data);
	};
	const isComplete = () => {
		return Boolean(data.checkInTime);
		// NOTA: Considerar esta validación si llegasen a requerir la marcación de salida
		// const { checkInTime, checkOutTime, classTime } = data;
		// return Boolean(checkInTime && checkOutTime && classTime);
	};
	return {
		value: data,
		fill: fillData,
		isComplete,
		isLoaded,
	};
};

export default useDataTeacherAttendance;
